import React, { useEffect } from 'react';
import GrantMathLavaLamp from './GrantMathLavaLamp';
import globalHeartbeat from '../utils/globalHeartbeatAudio';

/**
 * How It Works Landing - Third Page
 * Explains Terminal vs Creekside, Daily Wisdom, Federation ecosystem
 */
const HowItWorksLanding = ({ onContinue }) => {
  useEffect(() => {
    if (globalHeartbeat) {
      globalHeartbeat.setEnabled(true);
    }
  }, []);

  return (
    <div 
      className="min-h-screen flex items-start justify-start relative overflow-hidden cursor-pointer"
      onClick={onContinue}
    >
      {/* Ultra Deep Zoom - 6x */}
      <div 
        className="absolute inset-0" 
        style={{ 
          transform: 'scale(6)',
          transformOrigin: 'center',
          filter: 'blur(1.5px)',
          opacity: 0.85
        }}
      >
        <GrantMathLavaLamp params={{ 
          energy: 0.55, 
          warmth: 0.7, 
          complexity: 0.6, 
          harmony: 0.8, 
          expansion: 0.58 
        }} />
      </div>

      {/* Ultra Black Vignette */}
      <div 
        className="absolute inset-0"
        style={{
          background: 'radial-gradient(circle at center, transparent 0%, rgba(0,0,0,0.85) 35%, rgba(0,0,0,0.98) 100%)'
        }}
      />

      {/* Content - Top-left, warm off-whites */}
      <div className="relative z-10 px-8 md:px-12 pt-20 md:pt-32 max-w-2xl animate-fadeFromCenter">
        <div 
          className="space-y-6 leading-relaxed"
          style={{ 
            fontFamily: '"Cormorant Garamond", "Libre Baskerville", serif',
            color: '#F5F5DC',
            textShadow: '0 0 40px rgba(245, 245, 220, 0.3)',
            fontSize: '1rem',
            fontWeight: '300',
            lineHeight: '1.8'
          }}
        >
          <p className="text-2xl md:text-3xl font-light" style={{ color: '#FFF8F0' }}>
            How It Works
          </p>

          <p className="text-base md:text-lg">
            Use this tool for any type of inquiry.
          </p>

          <div className="space-y-3">
            <p className="text-base">
              The <span className="font-medium" style={{ color: '#E0E0D0' }}>TERMINAL</span> side is more analytical and project-minded—
              sharp, tactical, powerful.
            </p>

            <p className="text-base">
              The <span className="font-medium" style={{ color: '#E0E0D0' }}>CREEKSIDE</span> is more poetic and gentle and patient—
              flowing, nurturing, maternal.
            </p>
          </div>

          <p className="text-sm md:text-base opacity-90 italic">
            We are always guided by the basic principles of helping families belong to each other again.
          </p>

          <p className="text-base">
            <span className="font-medium" style={{ color: '#FFE4B5' }}>Daily wisdom outputs</span> assimilate all of our thoughts
            into generated article sets—collective intelligence emerging from individual conversations.
          </p>

          <p className="text-sm">
            You can switch between Terminal and Creekside anytime.
          </p>

          <p className="text-sm opacity-80">
            This is part of the broader ecosystem of{' '}
            <a 
              href="https://belongingsessions.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="underline hover:opacity-100 transition-opacity"
              style={{ color: '#FFE4B5' }}
            >
              belongingsessions.com
            </a>
            —a federation of families learning to thrive together.
          </p>

          <div className="text-center mt-12">
            <div 
              className="text-sm animate-pulse opacity-60"
              style={{ fontStyle: 'italic' }}
            >
              [ begin ]
            </div>
          </div>
        </div>
      </div>

      {/* Bottom hint */}
      <div 
        className="absolute bottom-8 right-8 text-xs italic opacity-10 text-right"
        style={{ 
          fontFamily: '"Cormorant Garamond", serif',
          color: '#F5F5DC'
        }}
      >
        alpha + theta<br/>
        analytical + nurturing<br/>
        together
      </div>
    </div>
  );
};

export default HowItWorksLanding;
